module.exports = "https://www.gc-pro.gnp.com.mx/72f648a637389a5958f68aa9ad43fbfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-contratante-danios.svg
// module id = 8080
// module chunks = 0